import { RootState } from '../store';

export const newsSelector = (state: RootState) => ({
  isNewsLoading: state.news.isNewsLoading,
  news: state.news.news,
});
